import APIService from '@/services/api'
import { getSections } from '@/services/data'
import { getMapDataFromExhibitedWork } from './resultmap.helper'

import {
  SEARCH_EXHIBITED_WORK_LIST,
  SEARCH_EXHIBITED_WORK_MAP,
  SEARCH_EXHIBITED_WORK_PERIOD,
  FETCH_RESULT_LIST,
  FETCH_RESULT_MAP,
  FETCH_RESULT_PERIOD,
  FETCH_RESULT_FILTERED,
  UPDATE_RESULT_LIST,
  UPDATE_RESULT_MAP,
  UPDATE_RESULT_PERIOD,
  UPDATE_RESULT_FILTERED,
  GET_EXHIBITED_WORK_FILTERED_BY_COLUMN,
  ERROR_API,
  ITEMS_PER_PAGE_FOR_MAP_DISPLAY
} from './constants'

import { EXHIBITED_WORK, getFiltersComputed } from '../../services/filters'

export const actionsExhibitedWork = {
  [SEARCH_EXHIBITED_WORK_LIST] ({commit, state},
    { value, order, direction, page, itemsPerPage, begin, end, jsonFilters }) {
    commit(FETCH_RESULT_LIST)
    let filters = getFiltersComputed(
      EXHIBITED_WORK,
      [],
      { value, order, direction, page, itemsPerPage, begin, end, jsonFilters }
    )

    APIService.searchExhibitedWork({
      transform: true,
      filters,
      satisfy: 'all',
      order: {
        column: order || 'begin_date',
        direction: direction || 'ASC'
      },
      page: {
        number: page,
        itemsPerPage
      }
    }).then(json => {
      commit(UPDATE_RESULT_LIST, {
        results: json.visu_exhibited_work || [],
        total: json._results || 0
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  },
  [GET_EXHIBITED_WORK_FILTERED_BY_COLUMN] ({commit, state},
    { value, column, objectToIncrement, jsonFilters }) {
    commit(FETCH_RESULT_FILTERED, {
      objectToIncrement
    })
    let filtersComputed = []
    if (Array.isArray(jsonFilters)) {
      filtersComputed = [...jsonFilters]
    } else {
      if (value) {
        filtersComputed.push({
          property: column,
          matchType: 'eq',
          value: value
        })
      }
    }
    APIService.searchExhibitedWork({
      transform: true,
      filters: filtersComputed,
      order: {
        column: 'id',
        direction: 'ASC'
      },
      satisfy: 'all'
    }).then(json => {
      const data = getSections(json.visu_exhibited_work)
      commit(UPDATE_RESULT_FILTERED, {
        objectToIncrement,
        results: data.sections || [],
        count: data.count || 0
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  },
  [SEARCH_EXHIBITED_WORK_MAP] ({commit, state},
    { value, begin, end, jsonFilters }) {
    commit(FETCH_RESULT_MAP)
    let filters = getFiltersComputed(
      EXHIBITED_WORK,
      [{
        property: 'section_x',
        matchType: 'nis',
        value: null
      }],
      { value, begin, end, jsonFilters }
    )

    APIService.searchExhibitedWork({
      transform: true,
      filters,
      satisfy: 'all',
      order: {
        column: 'begin_date',
        direction: 'DESC'
      },
      page: {
        number: 1,
        itemsPerPage: ITEMS_PER_PAGE_FOR_MAP_DISPLAY
      }
      // columns: [
      //   'id_exhibition',
      //   'id',
      //   'title',
      //   'exhibition_title',
      //   'exhibition_city',
      //   'begin_date',
      //   'space',
      //   'section_x',
      //   'section_y',
      //   'section_title'
      // ].join(',')
    }).then(json => {
      const results = getMapDataFromExhibitedWork(json.visu_exhibited_work)
      commit(UPDATE_RESULT_MAP, {
        results: results,
        total: json._results || 0
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  },
  [SEARCH_EXHIBITED_WORK_PERIOD] ({commit, state},
    { value, jsonFilters }) {
    commit(FETCH_RESULT_PERIOD)
    let filters = getFiltersComputed(
      EXHIBITED_WORK,
      [],
      { value, jsonFilters }
    )
    APIService.searchExhibitedWork({
      filters,
      transform: true,
      satisfy: 'all',
      order: {
        column: 'begin_date',
        direction: 'ASC'
      },
      page: {
        number: 1,
        itemsPerPage: 1
      },
      columns: 'begin_date'
    }).then(jsonBegin => {
      APIService.searchExhibitedWork({
        filters,
        transform: true,
        satisfy: 'all',
        order: {
          column: 'begin_date',
          direction: 'DESC'
        },
        page: {
          number: 1,
          itemsPerPage: 1
        },
        columns: 'begin_date'
      }).then(jsonEnd => {
        commit(UPDATE_RESULT_PERIOD, {
          period: {
            begin: jsonBegin.visu_exhibited_work[0] && jsonBegin.visu_exhibited_work[0].begin_date,
            end: jsonEnd.visu_exhibited_work[0] && jsonEnd.visu_exhibited_work[0].begin_date
          }
        })
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  }
}

export default actionsExhibitedWork



// WEBPACK FOOTER //
// ./src/store/search/actions.exhibitedWork.js